
(function ($, undefined) {
    $.fn.getCursorPosition = function() {
        var el = $(this).get(0);
        var pos = 0;
        if('selectionStart' in el) {
            pos = el.selectionStart;
        } else if('selection' in document) {
            el.focus();
            var Sel = document.selection.createRange();
            var SelLength = document.selection.createRange().text.length;
            Sel.moveStart('character', -el.value.length);
            pos = Sel.text.length - SelLength;
        }
        return pos;
    }
})(jQuery);

$.fn.caret = function (begin, end) {
    if (this.length == 0) return;
    if (typeof begin == 'number') {
        end = (typeof end == 'number') ? end : begin;
        return this.each(function () {
            if (this.setSelectionRange) {
                this.setSelectionRange(begin, end);
            }
            else if (this.createTextRange) {
                var range = this.createTextRange();
                range.collapse(true);
                range.moveEnd('character', end);
                range.moveStart('character', begin);
                try { range.select(); } catch (ex) { }
            }
        });
    } else {
        if (this[0].setSelectionRange) {
            begin = this[0].selectionStart;
            end = this[0].selectionEnd;
        }
        else if (document.selection && document.selection.createRange) {
            var range = document.selection.createRange();
            begin = 0 - range.duplicate().moveStart('character', -100000);
            end = begin + range.text.length;
        }
        return { begin: begin, end: end, length: (end - begin) };
    }
};

function hexToRgb(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
}
window.hexToRgb = hexToRgb;

var loaderHtml = '<svg class="circular" viewBox="25 25 50 50"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg>';
$.fn.startProcess = function(message) {
    var me = this;
    if (me.find('>.process').length == 0) {
        me.addClass('position-relative');
        this.append($('<div class="process process-absolute">'+loaderHtml+'<div class="message"></div></div>'));
    }
    me.find('.process .message').html(message||'');
    me.prop('disabled', 'disabled');
    me.addClass('process-show').show();
};
$.fn.endProcess = function() {
    this.prop('disabled', null);
    this.removeClass('process-show');
};
$.fn.inputRunning = function() {
    this.parent().attr('data-procend', (new Date().getTime() + 1000)).startProcess();
};
$.fn.inputEndRunning = function(onEnded) {
    var el = this.parent();
    var ts = new Date().getTime();
    var tsend = parseInt(el.attr('data-procend'));
    if (ts > tsend) {
        el.endProcess();
        if (onEnded) onEnded();
    } else {
        setTimeout(function() {
            el.endProcess();
            if (onEnded) onEnded();
        }, tsend - ts);
    }
};
$.fn.toggleClassIf = function(cssClass, addClass) {
    if (addClass) this.addClass(cssClass);
    if (!addClass) this.removeClass(cssClass);
    return this;
};
$.fn.inputSuccessHint = function() {
    this.addClass('success-hint');
    setTimeout(function() {
        this.removeClass('success-hint');
    }.bind(this), 500);
};

$.fn.hasLoader = function(fullSize, message) {
    return $(this).find('.loader-text').length === 1;
};

$.fn.applyLoader = function(fullSize, message) {
    if ($(this).find('.loader-text').length === 0) {
        console.log("applyLoader", message);
        message = (message || '' != '') ? '<div class="d-inline-block m-2 loader-text">' + message + '</div>' : '';
        var indicatorCss = (message == '') ? 'indicator' : 'indicator bg bg-dark d-flex align-items-center';
        $(this).isLoading({
            text: '<div class=""><div class="' + indicatorCss + ' d-flex"><div class="d-inline-block m-2" style="height:25px;width:25px;">' + loaderHtml + '</div>' + message + '</div></div>',
            position: "overlay",
            class: ''
        });
        if (fullSize || false == true) {
            $($(this).find('.isloading-overlay')[0]).css({top: 0, left: 0, right: 0, bottom: 0, height: 'auto', width: 'auto'});
        }
    } else {
        $(this).find('.loader-text').html(message);
    }
};

$.fn.changeLoader = function(content) {
    $(this).find('.loader-text').html(content);
};

$.fn.hideLoader = function() {
    if ($(this).find('.isloading-wrapper').length >= 1) {
        console.log("hideLoader");
        $(this).isLoading('hide');
    }
};
